import { render, staticRenderFns } from "./QIP.vue?vue&type=template&id=238452be"
import script from "./QIP.vue?vue&type=script&lang=js"
export * from "./QIP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('238452be')) {
      api.createRecord('238452be', component.options)
    } else {
      api.reload('238452be', component.options)
    }
    module.hot.accept("./QIP.vue?vue&type=template&id=238452be", function () {
      api.rerender('238452be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/QSPI/OtherTargetMaintain/QIP.vue"
export default component.exports